import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { AppConfigService } from './app/core/services/app-config.service';

const configService = new AppConfigService();
configService.loadConfig().then(() => {
  // Store in window for global access before Angular bootstrap
  (window as any).__APP_CONFIG__ = configService;
  
  bootstrapApplication(AppComponent, appConfig)
    .catch((err) => console.error(err));
});